module.exports = require('./helpers/bundle-url').getBundleURL('aU9Vj') + "success.08c92973.mp3";